import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from 'components/Grid';
import { Heading, HeadingBoundary } from 'components/Heading';
import { Image } from 'components/Image';
import { Link } from 'components/Link';
import { Text } from 'components/Text';
import { VideoAutoplay } from 'components/VideoAutoplay';
import { cx } from 'utility';
import * as styles from './CardList.module.scss';

const propTypes = {
    background: PropTypes.bool,
    className: PropTypes.string,
    items: PropTypes.array,
    itemsPerRow: PropTypes.string,
};

const defaultProps = {
    background: false,
    className: '',
    items: [],
    itemsPerRow: '2',
};

function getClasses({ className, background, itemsPerRow }) {
    const classes = cx(
        className,
        styles['cardList'],
        background && styles['cardListOnSurface'],
        styles[`cardList${itemsPerRow}`],
    );

    return classes || undefined;
}

function CardList({
    background,
    className,
    items,
    itemsPerRow,
}) {
    const classes = getClasses({ className, background, itemsPerRow });

    return (
        <div className={classes}>
            <Grid>
                <div className={styles['container']}>
                    <div className={styles['list']}>
                        {items.map(({ card_description, card_image, card_link_text, card_link_url, card_title, card_video_autoplay, card_video_upload }, index) => {
                            const description = card_description?.text;
                            const image = card_image;
                            const linkText = card_link_text?.text;
                            const linkUrl = card_link_url;
                            const title = card_title?.text;
                            const videoAutoplay = card_video_autoplay;
                            const videoUpload = card_video_upload?.url;

                            return (
                                <div className={styles['item']} key={`card-list-item-${index}`}>
                                    <HeadingBoundary>
                                        {image?.url && (
                                            <div className={styles['imageContainer']}>
                                                <Image
                                                    className={styles['image']}
                                                    image={image}
                                                    size="small"
                                                />
                                                {videoUpload && (
                                                    <VideoAutoplay
                                                        autoPlay={videoAutoplay}
                                                        className={styles['videoUpload']}
                                                        videoUploadUrl={videoUpload}
                                                    />
                                                )}
                                            </div>
                                        )}
                                        <div className={styles['contentContainer']}>
                                            {title && (
                                                <Heading
                                                    className={styles['title']}
                                                    size={5}
                                                >
                                                    {title}
                                                </Heading>
                                            )}
                                            {description && (
                                                <Text
                                                    as="p"
                                                    className={styles['description']}
                                                    size={2}
                                                >
                                                    {description}
                                                </Text>
                                            )}
                                            {(linkText && (linkUrl?.url || linkUrl?.uid)) && (
                                                <div className={styles['linkContainer']}>
                                                    <Link className={styles['link']} emphasis="high" size={2} reverseUnderline={true} to={linkUrl}>{linkText}</Link>
                                                </div>
                                            )}
                                        </div>
                                    </HeadingBoundary>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Grid>
        </div>
    );
}

CardList.propTypes = propTypes;
CardList.defaultProps = defaultProps;

export { CardList };
